import DeleteDrEventModal from './DeleteDrEventModal';

export default DeleteDrEventModal;
